/**
 * Action types
 */

import { createTypes } from 'reduxsauce'
import { IComponentState } from '../root.types'
import { Report } from '../../application/models/report/report'
import { ActiveSearchResponse } from '../../application/models/report/active.search.response'
import { ActiveSearchSummary } from '../../application/models/report/active.search.summary'
// import { IComponentState, IPaginator, ISearch } from '../root.types'

export const ReportTypes = createTypes(`

    LOAD_REPORT_REQUEST
    LOAD_REPORT_SUCCESS
    LOAD_REPORT_FAILURE

    LOAD_ACTIVE_SEARCH_SUMMARY_REQUEST
    LOAD_ACTIVE_SEARCH_SUMMARY_SUCCESS
    LOAD_ACTIVE_SEARCH_SUMMARY_FAILURE
    
    LOAD_ACTIVE_SEARCH_RESPONSE_REQUEST
    LOAD_ACTIVE_SEARCH_RESPONSE_SUCCESS
    LOAD_ACTIVE_SEARCH_RESPONSE_FAILURE
`,
    {
        prefix: '@report/'
    }
)

/**
 * State type
 */
export interface IReportState {
    readonly report: IDataState
    readonly activeSearchResponse: IActiveSearchResponseState
    readonly activeSearchSummary: IActiveSearchSummaryState
    readonly filter: IFilter
}


export interface IDataState extends IComponentState {
    readonly data: Report
}

export interface IActiveSearchSummaryState extends IComponentState {
    readonly data: ActiveSearchSummary
}

export interface IActiveSearchResponseState extends IComponentState {
    readonly data: ActiveSearchResponse
}
export interface IFilter {
    readonly primaryDate?: string
    readonly secondaryDate?: string
    readonly state?: string
    readonly addressCity?: string
    readonly month?: {
        startDate: string
        endDate: string
    }
}
export interface GenericObject {
    readonly name: string
    readonly value: number
}